export default __webpack_public_path__ + "static/media/Diosprovee.b903a5c4.jpg";